import React, { memo } from "react";
import { CancelBookingPopupWrapper, CTAButton, CTAContainer, StyledHeaderText } from "./styles";
import { CANCEL_BOOKING_TEXTS } from "@dineout-payment-success-ui/constants/Constants";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";

interface ICancelBookingPopup {
    onCancelBooking: () => void;
    onClose: () => void;
    loading?: boolean;
}

const CancelBookingPopup: React.FC<ICancelBookingPopup> = ({ onClose, onCancelBooking, loading }) => {
    return (
        <CancelBookingPopupWrapper>
            <StyledHeaderText variant="V2.body1.neutral.regular" color="text_Highest_Emphasis">
                {CANCEL_BOOKING_TEXTS.POPUP_TEXT}
            </StyledHeaderText>
            <CTAContainer>
                <CTAButton buttonType={"secondary"} buttonSize={"small"} onClick={onCancelBooking} isCustomButton>
                    {loading ? (
                        <div>
                            <Loader
                                size="large"
                                type="secondary"
                                foregroundColor="primary"
                                backgroundColor="primary_Sub"
                                isDisabled={false}
                            />
                        </div>
                    ) : (
                        <Text variant={"V2.body1.neutral.bold"} color={"primary"}>
                            {CANCEL_BOOKING_TEXTS.POPUP_GO_AHEAD_TEXT}
                        </Text>
                    )}
                </CTAButton>

                <CTAButton buttonType={"primary"} buttonSize={"small"} onClick={onClose} isCustomButton>
                    <Text variant={"V2.body1.neutral.bold"} color={"text_inverse_Highest_Emphasis"}>
                        {CANCEL_BOOKING_TEXTS.POPUP_GO_BACK_TEXT}
                    </Text>
                </CTAButton>
            </CTAContainer>
        </CancelBookingPopupWrapper>
    );
};

export default memo(CancelBookingPopup);
